export default (() => {
    const timeline = document.querySelector('.Timeline');
    const cells = Array.from(document.querySelectorAll('.Timeline .Timeline__cell'));

    const centerActiveCell = () => {
        const index = cells.findIndex((cell) => cell.classList.contains('active'));
        timeline.scrollLeft = 80 * index;
    };

    if (timeline && cells.length > 7) {
        window.addEventListener('resize', centerActiveCell);
        centerActiveCell();
    }
})();
